import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useStyles } from './pill.styles';

function Pill ({ label, tone, dot, className, accentColor }) {
    const classes = useStyles({ accentColor });

    return (
        <span className={classnames(classes.pill, classes[tone], className)}>
            {dot && <span className={classes.dot}>●</span>}
            {label}
        </span>
    );
}

Pill.propTypes = {
    label: PropTypes.node.isRequired,
    tone: PropTypes.oneOf(['current', 'popular', 'active', 'tier', 'cancellationPending']).isRequired,
    dot: PropTypes.bool,
    className: PropTypes.string,
    accentColor: PropTypes.string,
};

Pill.defaultProps = {
    dot: false,
    className: '',
    accentColor: null,
};

export default Pill;
